import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import art from "../../static/js/proto/art/Art.js";
import Params from './modules/Params';
import setPage from './setPage/setPage';
import priceTick from './priceTick/priceTick';
import keyBoard from './keyBoard/keyBoard';

////////////////////////////////////////////////////////////////////////////////
const store = new Vuex.Store({
  modules: {
    Params,
    setPage,
    priceTick,
    keyBoard,
  },
  state: {
    autoClosed: false, // 网络自动断开
    targetSelected: {}, // 自选合约列表
    bottomIndex: 0,
    selectTargets: [], // 自选列表
    marketDetailNav: null,
  },

  getters: {

  },

  mutations: {
    // 网络自动断开：set
    autoClose(state, autoClosed) {
      state.autoClosed = autoClosed;
    },

    // 自选合约列表：加载数据/添加/删除
    selectLoad(state, value) {
      if (value === undefined) {
        state.targetSelected = {};
        return;
      }
      state.targetSelected = value;
    },
    selectInsert(state, targetId) {
      Vue.set(state.targetSelected, targetId, true);
    },
    selectRemove(state, targetId) {
      Vue.delete(state.targetSelected, targetId);
    },
    selectIndex(state, index) {
      state.bottomIndex = index;
    },
    upDataSelect(state, context) {
      state.selectTargets = context;
    },
    marketDetailNavSet(state, context) {
      state.marketDetailNav = context;
    },
    marketDetailNavClear(state) {
      state.marketDetailNav = null;
    },
  },
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js